import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

// value: { billable: true | false | null, amount: string }
export const InvoiceFields = ({ value, onChange, testid = "invoice" }) => (
  <div data-testid={`${testid}-fields`}>
    <Label className="text-xs uppercase tracking-wider text-slate-500">Billing</Label>
    <div className="mt-1 grid grid-cols-2 gap-2">
      {[[true, "To invoice"], [false, "Not to invoice"]].map(([v, label]) => (
        <button key={label} type="button" data-testid={`${testid}-${v ? "bill" : "nobill"}`} onClick={() => onChange({ ...value, billable: value.billable === v ? null : v })}
          className={`border rounded-md px-3 py-2 text-sm transition-colors ${value.billable === v ? (v ? "border-emerald-600 bg-emerald-50 text-emerald-800" : "border-blue-700 bg-slate-100") : "border-slate-200 hover:border-slate-400"}`}>
          {label}
        </button>
      ))}
    </div>
    {value.billable && (
      <div className="mt-2">
        <Label className="text-xs text-slate-500">Fee amount (₹)</Label>
        <Input data-testid={`${testid}-amount`} type="number" min="0" step="0.01" value={value.amount} onChange={(e) => onChange({ ...value, amount: e.target.value })}
          placeholder="e.g. 1500" className="mt-1 mono" />
      </div>
    )}
  </div>
);

export const invoicePayload = (v) => ({
  billable: v.billable,
  invoice_amount: v.billable && v.amount !== "" ? parseFloat(v.amount) : null,
});
